// extracted by mini-css-extract-plugin
export default {"box":"user_box__bBnFU","perfil":"user_perfil__Ul-jn","botoes":"user_botoes__pw6V9"};